export default "__VITE_ASSET__DX_63O0S__"